import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'

export default {
  GET_EQUIPMENT_PLACES: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentPlaces.all}`, {}, true)
        .then(response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('setEquipmentPlaces', data.items)
          }

          resolve()
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.notFoundMessage)

          reject()
        })
    })
  },
}
